import type { DSEmojiPickerReaction } from "@/src/design_system/button_and_controls/emoji_picker/types/props";
import type { DSUser } from "@/src/design_system/shared/types/user";

const isObject = (value: unknown): value is Record<string, unknown> => {
  return Boolean(value && typeof value === "object" && !Array.isArray(value));
};

const isPickerUser = (value: unknown): value is DSUser => {
  return isObject(value) && Object.values(value).every(field => field === undefined || typeof field === "string");
};

const isPickerReaction = (value: unknown): value is DSEmojiPickerReaction => {
  if (!isObject(value)) return false;

  return typeof value.emoji === "string" && typeof value.isOwn === "boolean" && isPickerUser(value.user);
};

export const sanitizeEmojiPickerReactions = (value: unknown): DSEmojiPickerReaction[] => {
  return Array.isArray(value) ? value.filter(isPickerReaction) : [];
};
